import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import './AdminLayout.css';
import { Layout, Menu, Input, Avatar, Button, Dropdown, message } from 'antd';
import { DashboardOutlined, ShoppingOutlined, PlusCircleOutlined, TagsOutlined, BellOutlined, MenuFoldOutlined, MenuUnfoldOutlined, LogoutOutlined, UserOutlined, PictureOutlined, SearchOutlined } from '@ant-design/icons';
const { Header, Sider, Content } = Layout;

const AdminLayout = ({ children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [productsDropdownOpen, setProductsDropdownOpen] = useState(false);
  const [searchValue, setSearchValue] = useState('');
  const { user, logout, isAdmin } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const handleSearch = (value) => {
    if (!value.trim()) {
      message.warning('Veuillez saisir un terme de recherche');
      return;
    }

    // Rediriger vers la page des produits avec le terme de recherche
    navigate(`/admin/products?search=${encodeURIComponent(value.trim())}`);
  };

  const handleSearchChange = (e) => {
    setSearchValue(e.target.value);
  };

  const navigationItems = [
    {
      path: '/admin/dashboard',
      label: 'Tableau de bord',
      icon: 'fas fa-tachometer-alt',
      exact: true
    },
    {
      path: '/admin/products',
      label: 'Tous les produits',
      icon: 'fas fa-box'
    },
    {
      path: '/admin/products/new',
      label: 'Nouveau produit',
      icon: 'fas fa-plus-circle'
    },
    {
      path: '/admin/categories',
      label: 'Catégories',
      icon: 'fas fa-tags'
    },
    {
      path: '/admin/categories/new',
      label: 'Catégories',
      icon: 'fas fa-tags'
    },
    {
      path: '/admin/quotes',
      label: 'Demandes de devis',
      icon: 'fas fa-file-invoice'
    }
  ];

  const isActivePath = (path, exact = false) => {
    if (exact) {
      return location.pathname === path;
    }
    return location.pathname.startsWith(path);
  };

  const topMenuSelectedKey = (() => {
    if (location.pathname.startsWith('/admin/products')) return '/admin/products';
    if (location.pathname.startsWith('/admin/categories')) return '/admin/categories';
    if (location.pathname.startsWith('/admin/dashboard')) return '/admin/dashboard';
    return '/admin/dashboard';
  })();

  const NavItem = ({ item }) => {
    const isActive = isActivePath(item.path, item.exact);

    return (
      <li className={`nav-item ${isActive ? 'nav-item--active' : ''}`}>
        <Link
          to={item.path}
          className="nav-link"
        >
          <i className={item.icon}></i>
          <span>{item.label}</span>
        </Link>
      </li>
    );
  };

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Sider width={240} theme="light" style={{ background: '#fff', borderRight: '1px solid #f0f0f0', display: 'flex', flexDirection: 'column' }}>
        <div style={{ padding: 16, textAlign: 'center' }}>
          <Link to="/admin/dashboard">
            <img src="/images/LOGO.png" alt="DOMOELEC" height={120} />
          </Link>
        </div>
        <Menu theme="light" mode="inline" selectedKeys={[location.pathname]} style={{ flex: 1 }}>
          <Menu.Item key="/admin/dashboard" icon={<DashboardOutlined />}> <Link to="/admin/dashboard">Tableau de bord</Link> </Menu.Item>
          <Menu.SubMenu key="products" icon={<ShoppingOutlined />} title="Produits">
            <Menu.Item key="/admin/products/new" icon={<PlusCircleOutlined />}> <Link to="/admin/products/new">Nouveau produit</Link> </Menu.Item>
            <Menu.Item key="/admin/products" icon={<ShoppingOutlined />}> <Link to="/admin/products">Liste produits</Link> </Menu.Item>
          </Menu.SubMenu>

          <Menu.SubMenu key="/admin/categories" icon={<ShoppingOutlined />} title="Categories">
            <Menu.Item key="/admin/categories/new" icon={<PlusCircleOutlined />}> <Link to="/admin/categories/new">Nouveau categorie</Link> </Menu.Item>
            <Menu.Item key="/admin/categories" icon={<ShoppingOutlined />}> <Link to="/admin/categories">Liste categories</Link> </Menu.Item>
          </Menu.SubMenu>
          <Menu.SubMenu key="/admin/blogs" icon={<ShoppingOutlined />} title="Blog">
            <Menu.Item key="/admin/blogs/new" icon={<PlusCircleOutlined />}> <Link to="/admin/blogs/new">Nouvel article</Link> </Menu.Item>
            <Menu.Item key="/admin/blogs" icon={<ShoppingOutlined />}> <Link to="/admin/blogs">Liste des articles</Link> </Menu.Item>
          </Menu.SubMenu>
          <Menu.Item key="/admin/advertisements" icon={<PictureOutlined />}> <Link to="/admin/advertisements">Publicités</Link> </Menu.Item>
        </Menu>
      </Sider>
      <Layout>
        <Header style={{ background: '#fff', padding: '0 16px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', borderBottom: '1px solid #f0f0f0' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            <Input.Search 
              placeholder="Rechercher des produits..." 
              allowClear 
              style={{ width: 320 }}
              value={searchValue}
              onChange={handleSearchChange}
              onSearch={handleSearch}
              enterButton={<SearchOutlined />}
            />
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            <Dropdown
              placement="bottomRight"
              menu={{
                items: [
                  {
                    key: 'logout',
                    icon: <LogoutOutlined />,
                    label: 'Déconnexion',
                    onClick: handleLogout
                  }
                ]
              }}
            >
              <div style={{ display: 'flex', alignItems: 'center', gap: 8, cursor: 'pointer' }}>
                <Avatar icon={<UserOutlined />} />
                <div style={{ lineHeight: 1 }}>
                  <div style={{ fontWeight: 600 }}>{user?.username}</div>
                  <div style={{ fontSize: 12, color: '#999' }}>{user?.role === 'admin' ? 'Administrateur' : 'Éditeur'}</div>
                </div>
              </div>
            </Dropdown>
          </div>
        </Header>
        <Content style={{ padding: 16 }}>
          {children}
        </Content>
      </Layout>
    </Layout>
  );
};

export default AdminLayout;
